import { MessagePaths, useMessagesTranslation } from '@shared/i18n';
import { MemberadminResources } from '../types/MemberadminResources';

export const useMemberadminTranslation = () => useMessagesTranslation<MemberadminResources>();

export type MemberadminMessageKey = MessagePaths<MemberadminResources>;

export const useMemberadminTFunction = () => useMemberadminTranslation().t;

export type MemberadminTFunction = ReturnType<typeof useMemberadminTFunction>;
